<template>
    <div>
        <SToolbar>
            <KpIcon icon-cls="user" color="grey" left />
            <v-toolbar-title>{{ $t('admin') }}</v-toolbar-title>
        </SToolbar>

        <RequestedUserList session-key="requested-user-list" height="var(--usable-height-with-double-toolbar)" />
    </div>
</template>

<script>
import RequestedUserList from '@/components/requested_user/List.vue';

export default {
    name: 'RequestedUserIndex',

    components: {
        RequestedUserList,
    },
};
</script>
